import { contactsService } from "@/api/services/contacts.service";
import { shoppingCentresService } from "@/api/services/shoppingCentres.service";
const LIST_PAGE_SIZE = 50;
/**
 * Resolves a shopping centre UUID from a display name using the list API search.
 * Prefers exact scName match (trim), then case-insensitive equality.
 */
export async function findShoppingCentreIdByName(name) {
    const trimmed = name.trim();
    if (!trimmed)
        return null;
    try {
        const response = await shoppingCentresService.getShoppingCentres({
            search: trimmed,
            pageSize: LIST_PAGE_SIZE,
        });
        const list = response.data.data || [];
        const exact = list.find((c) => (c.scName ?? "").trim() === trimmed);
        if (exact)
            return exact.id;
        const lower = trimmed.toLowerCase();
        const ci = list.find((c) => (c.scName ?? "").trim().toLowerCase() === lower);
        return ci?.id ?? null;
    }
    catch {
        return null;
    }
}
/**
 * Loads contact detail and matches ContactDetail.shoppingCenter (CRM string) to a shopping centre id.
 */
export async function resolveShoppingCentreIdFromContact(contactId) {
    if (!contactId.trim())
        return null;
    try {
        const res = await contactsService.getContact(contactId, 1, 1);
        const name = res.data.shoppingCenter?.trim();
        if (!name)
            return null;
        return findShoppingCentreIdByName(name);
    }
    catch {
        return null;
    }
}
